import { createAction, props } from '@ngrx/store';

export const setRegisterId = createAction(
    '[Register Component] Set Id',
    props<{ registerId: number }>(),
);
export const resetRegisterId = createAction('[Register Component] Reset Id');
